import * as $ from 'jquery';

/**
 * 公共方法
 */

// 防抖, 针对于高频事件的处理方式，在一定时间内重复触发时，会重新进行延时
export function debounce(handle, waitTime) {
  let timer;
  return function() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    timer = setTimeout(handle.call(this, ...arguments), waitTime);
  };
}

// 节流, 针对于高频事件的处理方式，在一定时间内，只会触发一次，使用时间戳+定时器的方式保证最后一次始终会被执行
export function throttle(func, delay) {
  let timer;
  let startTime = Date.now();
  return function() {
    const curTime = Date.now();
    const remaining = delay - (curTime - startTime);
    clearTimeout(timer);
    if (remaining <= 0) {
      func.apply(this, ...arguments);
      startTime = Date.now();
    } else {
      timer = setTimeout(func.apply(this, ...arguments), remaining);
    }
  };
}

// 针对左侧树右侧表的页面，表区高度大于树区时以表区高度为准，表区高度小于树区时，高度默认550px
export function treeScrollcontrl(tableId, tableWrapperId, treeWrapperId) {
  const timeout = setTimeout(() => {
    const cardTableEl: any = $(tableId);
    const options = { attributes: true, childList: true, subtree: true, attributeOldValue: true };
    const mutationObserver = new MutationObserver(
      debounce(() => {
        const rightHeight = parseFloat($(tableWrapperId).css('height'));
        if (rightHeight < 550) {
          $(treeWrapperId).css('height', '670.5px');
        } else {
          $(treeWrapperId).css('height', rightHeight + 'px');
        }
      }, 0),
    );
    mutationObserver.observe(cardTableEl[0], options);
    clearTimeout(timeout);
  }, 0);
}

// 处理字符串中的换行，以便正常显示
export function formatLineFeed(value: any) {
  if (typeof value === 'string') {
    return value.replace(/\n/g, '<br/>');
  }
  return value;
}

// 千分符格式化
export function formatNumber(num) {
  const numStr = num.toString();
  let resultStr = '';
  let k = 0;
  for (let i = numStr.length - 1; i >= 0; i--) {
    k++;
    if (k % 3 === 0) {
      resultStr = ',' + numStr.charAt(i) + resultStr;
    } else {
      resultStr = numStr.charAt(i) + resultStr;
    }
  }
  if (resultStr.charAt(0) === ',') {
    resultStr = resultStr.slice(1, resultStr.length);
  }
  return resultStr;
}

export function generateUUID() {
  let d = new Date().getTime();
  let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    let r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid;
}

// 校验图片地址为空、无效的情况
export function checkImgSrc(imgSrc): Promise<void> {
  return new Promise((resolve, reject) => {
    if (!imgSrc || !imgSrc.toLocaleLowerCase().trim()) {
      reject({
        type: 1,
        desc: '地址为空',
      });
    } else {
      const imgObj: any = new Image();
      imgObj.src = imgSrc;
      imgObj.onload = () => {
        resolve();
      };
      imgObj.onerror = () => {
        reject({
          type: 2,
          desc: '地址无效',
        });
      };
    }
  });
}

// 将source合并到target上，并返回target，其中合并的过程为深克隆/复制
export function deepMerge(source, target?) {
  const getDefaultObj = (_s, _t) => {
    let _r;
    switch (true) {
      case !!_t:
        _r = _t;
        break;
      case isObject(_s):
        _r = {};
        break;
      case isArray(_s):
        _r = [];
        break;
      default:
        break;
    }
    return _r;
  };
  const copyFn = (s_obj, t_obj) => {
    t_obj = getDefaultObj(s_obj, t_obj);
    for (const key in s_obj) {
      if (s_obj.hasOwnProperty(key)) {
        if (isObject(s_obj[key]) || isArray(s_obj[key])) {
          t_obj[key] = copyFn(s_obj[key], t_obj[key]);
        } else {
          t_obj[key] = s_obj[key];
        }
      }
    }

    return t_obj;
  };
  return copyFn(source, target);
}

// 判断对象
export function isObject(target) {
  return '[object Object]' === Object.prototype.toString.call(target);
}

// 判断数组
export function isArray(target) {
  return '[object Array]' === Object.prototype.toString.call(target);
}

// // url解析
// export function parseUrl(url) {
//   const parsedObj = {
//     path: '',
//     params: {},
//   };
//   if (url) {
//     const nodeURL = require('url');
//     const format = nodeURL.parse(url);
//     if (format) {
//       if (format.query) {
//         const paramsArr = format.query.split('&');
//         paramsArr.forEach(item => {
//           const tempArr = item.split('=');
//           parsedObj.params[tempArr[0]] = tempArr[1];
//         });
//       }
//       parsedObj.path = format.pathname;
//     }
//   }
//   return parsedObj;
// }

// 是否是json字符串
export function isJsonString(str) {
  try {
    if (typeof JSON.parse(str) === 'object') {
      return true;
    }
  } catch (e) {}
  return false;
}

// 判断两个对象是否相等（拥有一样的键和键值）
export function isObjectValueEqual(a, b) {
  var aProps = Object.getOwnPropertyNames(a);
  var bProps = Object.getOwnPropertyNames(b);
  if (aProps.length != bProps.length) {
    return false;
  }
  for (var i = 0; i < aProps.length; i++) {
    var propName = aProps[i];
    var propA = a[propName];
    var propB = b[propName];
    // 故先判断两边都有相同键名
    if (!b.hasOwnProperty(propName)) return false;
    if (propA instanceof Object) {
      if (this.isObjectValueEqual(propA, propB)) {
        // return true     这里不能return ,后面的对象还没判断
      } else {
        return false;
      }
    } else if (propA !== propB) {
      return false;
    } else {
    }
  }
  return true;
}
